import { useLanguage } from "@/runtime/i18n/language"
import { NEW_SESSION_CONTENT_WIDTH } from "./layout"
import "./view.css"
import "./loading.css"

export function NewSessionLoading() {
  const language = useLanguage()
  return (
    <div
      data-component="new-session-loading"
      class="sair-new-session relative size-full flex-1 min-h-0"
      role="status"
      aria-label={language.t("common.loading")}
      aria-busy="true"
    >
      <div class="sair-new-session-body" aria-hidden="true">
        <div class={`sair-new-session-content ${NEW_SESSION_CONTENT_WIDTH}`}>
          <div class="sair-new-session-intro">
            <div class="sair-new-session-figure sair-new-session-placeholder" />
            <div class="sair-new-session-placeholder" data-slot="heading" />
          </div>
          <div class="sair-new-session-composer">
            <div class="sair-new-session-placeholder" data-slot="project" />
            <div class="sair-new-session-placeholder" data-slot="composer" />
          </div>
        </div>
      </div>
    </div>
  )
}
